<template>
  <div>
    <!-- <a :src="url" v-for="url of urls" :key="url">{{url}}</a> -->
  </div>
</template>

<script>
export default {
  props: ["urls"]
};
</script>